import React from 'react';
import { Rotation } from './Rotation';

const ANSWERS = {
  Espresso: [
    'roast:espresso',
    'grind:Whole Bean;specificGrind:null',
    'size:12',
    'price_type:standard;size:12',
    'dateOverride:0',
  ],
  PremiumLight: [
    'roast:light',
    'grind:Whole Bean;specificGrind:null',
    'size:12',
    'price_type:premium;size:12',
    'dateOverride:0',
  ],
  Medium: [
    'roast:medium',
    'grind:Whole Bean;specificGrind:null',
    'size:12',
    'price_type:standard;size:12',
    'dateOverride:0',
  ],
  Dark: [
    'roast:dark',
    'grind:Whole Bean;specificGrind:null',
    'size:12',
    'price_type:standard;size:12',
    'dateOverride:0',
  ],
};

export const Rotations = () => (
  <>
    <Rotation
      name="Espresso Rotation"
      image="https://bottomless.imgix.net/landing/espresso-rotation-art.png"
      answers={ANSWERS.Espresso}
      index={0}
    />
    <Rotation
      name="Medium Roast Rotation"
      image="https://bottomless.imgix.net/landing/medium-roast-rotation-art.png"
      answers={ANSWERS.Medium}
      index={1}
    />
    <Rotation
      name="Premium Light Rotation"
      image="https://bottomless.imgix.net/landing/premium-light-rotation-art.png"
      answers={ANSWERS.PremiumLight}
      index={2}
    />
    <Rotation
      name="Dark Roast Rotation"
      image="https://bottomless.imgix.net/landing/dark-roast-rotation-art.png"
      answers={ANSWERS.Dark}
      index={3}
    />
  </>
);
